<template>
  <div class="dashboard">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="stats">
        <div class="card" @click="goTo('/inventory')">
          <p class="stat">
            {{inventory}}
            <span>Inventory items</span>
          </p>
          <img src="@/assets/img/Inventory.svg" />
        </div>
        <div class="card" @click="goTo('/clients')">
          <p class="stat">
            {{ clients }}
            <span>Total Clients</span>
          </p>
          <img src="@/assets/img/Clients.svg" />
        </div>
        <div class="card" @click="goTo('/orders')">
          <p class="stat">
            {{ orders }}
            <span>Total Client Orders</span>
          </p>
          <img src="@/assets/img/Orders.svg" />
        </div>
        <div class="card" @click="goTo('/orders')">
          <p class="stat">
            {{ purchase_orders }}
            <span>Total Purchase Orders</span>
          </p>
          <img src="@/assets/img/Orders.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "loginregister",
  components: {
    register: Register,
  },
  data() {
    return {
      clients: 0,
      orders: 0,
      purchase_orders: 0,
      inventory: 0,
      user: this.$store.state.reseller,
    };
  },
  mounted() {},
  async created() {
    await Promise.all([
      this.getClientsTotal(),
      this.getOrdersTotal(),
      this.getPurchaseOrdersTotal(),
      this.getInventoryTotal()
    ]);
  },
  updated() {},
  methods: {
    getClientsTotal() {
      return db.collection("reseller_profile")
        .doc(this.user.id)
        .collection("clients")
        .get()
        .then((snap) => {
          this.clients = snap.size;
        });
    },
    getOrdersTotal() {
      return db.collection("reseller_profile")
        .doc(this.user.id)
        .collection("orders")
        .get()
        .then((snap) => {
          this.orders = snap.size;
        });
    },
    getPurchaseOrdersTotal() {
      return db.collection("reseller_profile")
        .doc(this.user.id)
        .collection("purchase_orders")
        .get()
        .then((snap) => {
          this.purchase_orders = snap.size;
        });
    },
    getInventoryTotal(){
      return db.collection("reseller_profile")
        .doc(this.user.id)
        .collection("inventory")
        .get()
        .then((snap) => {
          this.inventory = snap.size;
        });
    }
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 800px;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    @media screen and (max-width: 700px) {
      width: 100% !important;
      padding: 20px;
      padding-top: 40px;
    }
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      @media screen and (max-width: 700px) {
        font-size: 60px;
      }
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}
</style>
